import { render, staticRenderFns } from "./healthy.vue?vue&type=template&id=5e348efb&"
import script from "./healthy.vue?vue&type=script&lang=js&"
export * from "./healthy.vue?vue&type=script&lang=js&"
import style0 from "./healthy.vue?vue&type=style&index=0&id=5e348efb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports